import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";

export type FoAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatFoToastLabel(code: string | null | undefined, description?: string | null): string {
    const codeText = typeof code === "string" ? code.trim() : "";
    if (codeText.length > 0) return codeText;
    const descText = typeof description === "string" ? description.trim() : "";
    return descText.length > 0 ? descText : EntityLabels.facilityOperation;
}

export function getFoAdminActionSuccessMessage(
    kind: FoAdminConfirmKind,
    code: string | null | undefined,
    description?: string | null
): string {
    const label = formatFoToastLabel(code, description);
    const successByKind: Record<FoAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

type FoRow = { id: string; code?: string | null; description?: string | null };

export const buildFoAdminPagedListActions = (openConfirm: (kind: FoAdminConfirmKind, item: FoRow) => void) =>
    buildRecordLifecyclePagedListActions<FoRow>(openConfirm, { activeMember: "isActive" });
